import type { Case } from '../../data/types';
import { useAppDispatch } from '../hooks';
import { setCaseAction, updateCaseAction, clearCaseAction } from '../reducers/caseReducer';

export const useCaseActions = () => {

    const dispatch = useAppDispatch();

    const setCase = (caseObj: Case) => {
        dispatch(setCaseAction(caseObj));
    }

    const updateCase = (caseObj: Case) => {
        dispatch(updateCaseAction(caseObj));
    }

    const clearCase = () => {
        dispatch(clearCaseAction());
    }

    return { setCase, updateCase, clearCase };
}
